import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const LegalNotice = () => {
  const { lang } = useLanguage();

  const content = {
    en: {
      title: 'Legal Notice',
      info: 'Information according to § 5 TMG',
      entity: 'Stup-On Ideas Consulting',
      representative: 'Represented by:',
      name: 'Mr. Marvin Ziegenhorn',
      address: 'Address:',
      street: 'Theodor-Fahr-Straße 37',
      city: '22419 Hamburg',
      contact: 'Contact:',
      email: 'Email: hello@stup-on.de',
      disclaimer: 'Disclaimer',
      disclaimerText: 'The contents of our pages were created with great care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content.'
    },
    de: {
      title: 'Impressum',
      info: 'Angaben gemäß § 5 TMG',
      entity: 'Stup-On Ideas Consulting',
      representative: 'Vertreten durch:',
      name: 'Herr Marvin Ziegenhorn',
      address: 'Adresse:',
      street: 'Theodor-Fahr-Straße 37',
      city: '22419 Hamburg',
      contact: 'Kontakt:',
      email: 'E-Mail: hello@stup-on.de',
      disclaimer: 'Haftungsausschluss',
      disclaimerText: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.'
    }
  };

  const t = content[lang];

  return (
    <div className="pt-24 pb-16 min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100"
        >
          <h1 className="text-3xl font-bold text-gray-900 mb-8">{t.title}</h1>
          
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t.info}</h2>
              <p className="font-medium text-gray-800">{t.entity}</p>
              
              <div className="mt-4">
                <p className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-1">{t.representative}</p>
                <p>{t.name}</p>
              </div>

              <div className="mt-4">
                <p className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-1">{t.address}</p>
                <p>{t.street}</p>
                <p>{t.city}</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t.contact}</h2>
              <p>{t.email}</p>
            </section>

            <section className="pt-8 border-t border-gray-100">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t.disclaimer}</h2>
              <p className="text-sm text-gray-500 italic">
                {t.disclaimerText}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalNotice;